import React from 'react';
import { InPageAnchorNavigationStyles as S } from './InPageAnchorNavigation.styles';
import { useMeasure } from 'react-use';
const InPageAnchorNavigation = ({ anchors }) => {
    const [ref, bounds] = useMeasure();
    const [activeAnchor, setActiveAnchor] = React.useState(anchors[0].anchorId);
    const [navHeight, setNavHeight] = React.useState(0);
    React.useEffect(() => {
        if (navHeight === 0)
            return;
        const offset = 114 + navHeight;
        // Collect a list of all the anchor elements //
        const anchorElements = anchors
            .map((anchor) => document.getElementById(anchor.anchorId))
            .filter(Boolean);
        const handleScroll = () => {
            // Couple of edge cases - if we're at the bottom of the page, and the last one isn't counted as //
            // being in view yet, just count it as being in view //
            if (window.scrollY + window.innerHeight >= document.body.getBoundingClientRect().height) {
                setActiveAnchor(anchors[anchors.length - 1].anchorId);
                return;
            }
            // Determine which anchor is currently in view //
            const anchorInView = anchorElements.find((anchor) => {
                const rect = anchor.getBoundingClientRect();
                return rect.top <= offset && rect.bottom >= offset;
            });
            if (anchorInView) {
                setActiveAnchor(anchorInView.id);
                return;
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [anchors, navHeight]);
    React.useEffect(() => {
        // Also need to poll the size of the anchor navigation component and update the body tag with it //
        if (bounds.height > 0) {
            const bodyTag = document.querySelector('body');
            if (bodyTag) {
                const style = bodyTag.getAttribute('style');
                bodyTag.setAttribute('style', (style ? style.replace(/--inPageNavigationHeight: [\d.]+px;/g, '') : '') +
                    `--inPageNavigationHeight: ${bounds.height}px;`);
                bodyTag.setAttribute('data-has-in-page-navigation', 'true');
                setNavHeight(bounds.height);
            }
        }
    }, [bounds]);
    return (React.createElement(S.Container, { ref: ref },
        React.createElement(S.Inner, null, anchors.map((anchor, i) => (React.createElement(S.Item, { "data-active": activeAnchor === anchor.anchorId, key: i },
            React.createElement("a", { href: `#${anchor.anchorId}` }, anchor.label)))))));
};
export default InPageAnchorNavigation;
